import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CategoryEntity } from './categories.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as CategoryActions from './categories.actions';

export const CATEGORY_FEATURE_KEY = 'category';

export interface CategoryState extends EntityState<CategoryEntity> {
  categories: CategoryEntity[];
  loaded: boolean;
  error?: string | null;
  id: number | undefined;
}

export const categoryAdapter: EntityAdapter<CategoryEntity> = createEntityAdapter<CategoryEntity>();

export const initialCategoryState: CategoryState = categoryAdapter.getInitialState({
  categories: [],
  loaded: true,
  id: undefined,
});

const reducer = createReducer(
  initialCategoryState,
  on(CategoryActions.initCategories, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(CategoryActions.loadCategoriesSuccess, (state, { categories: categories }) => ({
    ...state,
    categories: categories,
    loaded: true,
    error: null,
  })),
  on(CategoryActions.loadCategoriesFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),
  on(CategoryActions.updateId, (state, { id }) => ({
    ...state,
    id: id,
  }))
);

export function categoryReducer(state: CategoryState | undefined, action: Action) {
  return reducer(state, action);
}
